/* global angular */
(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('focusElement', [function () {
    return {
      restrict: 'A',
      link: function link(scope, elem, attrs) {
        var brandColor = $('.navbar-default').css('background-color');
        var targetElement = $(attrs.focusElement);
        if (targetElement) {
          elem.on('mouseenter', function () {
            targetElement.css('box-shadow', "0px 0px 6px 2px ".concat(brandColor));
            targetElement.css('z-index', '1000');
          });
          elem.on('mouseleave', function () {
            targetElement.css('box-shadow', '');
            targetElement.css('z-index', '');
          });
        }
      }
    };
  }]);
})();
